import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';
import { ImageGenerator, GPTResearcher } from './Tools';
import {
  Login,
  Registration,
  VerifyEmail,
  ApiErrorWatcher,
} from '~/components/Auth';
import { Privacy } from '~/components/Privacy';
import { Terms } from '~/components/Terms';
import { AuthContextProvider } from '~/hooks/AuthContext';
import StartupLayout from './Layouts/Startup';
import LoginLayout from './Layouts/Login';
import dashboardRoutes from './Dashboard';
import ShareRoute from './ShareRoute';
import ChatRoute from './ChatRoute';
import Search from './Search';
import Root from './Root';
import NotFound from './NotFound';
import userManagerRoutes from './UserManager';
import { AuthenticateRoute } from '~/components/Auth';
import HelpAndFAQ from '~/components/Pages/FAQ/HelpAndFAQ';

const AuthLayout = () => (
  <AuthContextProvider>
    <Outlet />
    <ApiErrorWatcher />
  </AuthContextProvider>
);

export const router = createBrowserRouter([
  {
    path: 'share/:shareId',
    element: <ShareRoute />,
  },
  {
    path: '/',
    element: <StartupLayout />,
    children: [
      {
        path: 'register',
        element: <Registration />,
      },
      {
        path: 'privacy-policy',
        element: <Privacy />,
      },
      {
        path: 'terms-of-service',
        element: <Terms />,
      },
    ],
  },
  {
    path: 'verify',
    element: <VerifyEmail />,
  },
  {
    element: <AuthLayout />,
    children: [
      {
        path: '/',
        element: <LoginLayout />,
        children: [
          {
            path: 'login',
            element: <Login />,
          },
          {
            path: 'authenticate',
            element: <AuthenticateRoute />,
          },
        ],
      },
      {
        path: 'help-faq',
        element: <HelpAndFAQ />,
      },
      dashboardRoutes,
      userManagerRoutes,
      {
        path: '/',
        element: <Root />,
        children: [
          {
            index: true,
            element: <Navigate to="/c/new" replace={true} />,
          },
          {
            path: 'c/:conversationId?',
            element: <ChatRoute />,
          },
          {
            path: 'c/tools/image-generator',
            element: <ImageGenerator />,
          },
          // {
          //   path: 'c/tools/gpt-researcher',
          //   element: <GPTResearcher />,
          // },
          {
            path: 'search',
            element: <Search />,
          },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
]);
